import React from 'react';
import { Card, CardActions, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import ProfileTile from './profile-tile.png';

// Icons
import CommunicationPhone from 'material-ui/svg-icons/communication/phone';
import HardwareSmartphone from 'material-ui/svg-icons/hardware/smartphone';

const getEmailButton = (emails) => {
  let filteredEmails = emails.filter(email => email.email);

  if (!filteredEmails.length) return (
    <FlatButton
      labelStyle={cardStyles.emailButton}
      label={' '}
      disabled={true}
    />
  );
  let button = {};

  filteredEmails.forEach(email => {
    if (email.email) {
      button = (
        <FlatButton
          labelStyle={cardStyles.emailButton}
          onTouchTap={openEmail.bind(this, email.email)}
          label={email.email}
        />
      );
    }}
  );

  return button;
};

// Using this until FlatButton properly turns FlatButton to link
const openEmail = (emailText) => {
  window.location.href = `mailto:${emailText}`;
};

const containerWidth = '200px';

const cardStyles = {
  card: {
    flex: `1 1 ${containerWidth}`,
    margin: '3px',
    cursor: 'pointer',
  },
  overlay: {
    top: 0,
    bottom: 'auto',
  },
  overlayTitle: {
    margin: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  emailButton: {
    display: 'inline-block',
    width: containerWidth,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  mobileIcon: {
    verticalAlign: 'middle',
    paddingRight: '11px',
    width: '14px',
    height: '14px',
    marginLeft: '10px',
  },
};

const getColor = (number) => {
  if (Math.round(Math.random())) {
    return 'C2185B';
  } else {
    return '009688';
  }
};

function InfluencerTile(props) {
  const { influencer } = props;
  const colors = ['#F44336', '#00BCD4', '#FF5722', '#795548', '#4CAF50', '#9C27B0'];

  return (
    <Card key={influencer.id} style={cardStyles.card}>
      <CardMedia
        onTouchTap={props.handleViewInfluencerDetails.bind(this, influencer.id)}
        overlayContentStyle={cardStyles.overlay}
        overlay={
          <CardTitle
            title={<p style={cardStyles.overlayTitle}>{influencer.firstName}<br/>{influencer.lastName}</p>}
            subtitle={influencer.collectiveName}
          />
        }
        style={{
          backgroundColor: colors[influencer.id % colors.length],
        }}
      >
        <img src={influencer.avatarUrls ? influencer.avatarUrls.medium : ProfileTile} />
      </CardMedia>
      <CardTitle
        title={
          <span style={{ fontSize: '16px' }}>
            <CommunicationPhone style={{ verticalAlign: 'middle', paddingRight: '10px' }} />
            {influencer.phone ? influencer.phone : 'None Listed'}
          </span>
        }
        subtitle={
          influencer.mobile
          ?
          <span><HardwareSmartphone  style={cardStyles.mobileIcon}/>{influencer.mobile}</span>
          : ''
        }
      />
      <CardActions>
        {getEmailButton(influencer.emails)}
        <FlatButton
          primary={true}
          label="Edit"
          onTouchTap={props.handleEditInfluencer.bind(this, influencer.id)}
        />
        <FlatButton
          secondary={true}
          label="Remove"
          onTouchTap={props.openInfluencerDeleteWarning.bind(this, influencer.id)}
        />
      </CardActions>
    </Card>
  );
}

InfluencerTile.propTypes = {
  influencer: React.PropTypes.object.isRequired,
  handleEditInfluencer: React.PropTypes.func,
  openInfluencerDeleteWarning: React.PropTypes.func,
};

export default InfluencerTile;



/** WEBPACK FOOTER **
 ** ./components/InfluencerTile.js
 **/